import { render } from "./instructor-dashboard.vue?vue&type=template&id=8b7cc5fe"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__